import "./Skill.css"


function Skill(prop) {
  return (
    <div className="Skill">

    {/*Title Capsule*/}
    <div className="skillTitle">
        <h1>{prop.name}</h1>
    </div>

    {/*Drop down*/}

    <div className="dropDown">
        <p>Type: {prop.type}</p>
        <hr/>


        {prop.projects.length !== 0 ? (
            <p>Projects: {prop.projects}</p>
        ) : (<></>
        )}
        {prop.classes.length !== 0 ? (
            <p>Classes: {prop.classes}</p>
        ) : (<></>
        )}
        {prop.experiences.length !== 0 ? (
        <p>Experiences: {prop.experiences}</p>
        ) : ( <> </> )}
        {/*<p>Proficiency: {prop.proficiency}</p>*/}
    </div>

    {/**/}
    {/**/}
    </div>
  );
}

export default Skill;